module.exports = __webpack_public_path__ + "img/icon_btn_internet.eda2cf01.svg";